export const thumbailForSpeaker = (speaker) => {
    if (speaker.profile_image?.length && speaker.profile_image[0]?.url) {
        return speaker.profile_image[0];
    }
    return null;
}